import { render, staticRenderFns } from "./ClockBlockOverlay.vue?vue&type=template&id=4ca0b13e&scoped=true&"
import script from "./ClockBlockOverlay.ts?vue&type=script&lang=ts&"
export * from "./ClockBlockOverlay.ts?vue&type=script&lang=ts&"
import style0 from "./ClockBlockOverlay.vue?vue&type=style&index=0&id=4ca0b13e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca0b13e",
  null
  
)

export default component.exports